<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OPasswordInput v-model="model" :maxlength="maxlength" :placeholder="placeholder" :disabled="normalizedDisabled"
        @change="(attrs.onChange)"></OPasswordInput>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol, ElFormItem } from 'element-plus'
import type { FormPasswordInputProps } from './PasswordInput'
import OPasswordInput from '../../Input/PasswordInput/PasswordInput.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'
import { useAttrs } from 'vue'

defineOptions({ name: 'OFormPassword', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, maxlength, placeholder } = defineProps<FormPasswordInputProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
